import { useState, useCallback } from 'react';
import { generateProjectDescription, type ProjectDescInput } from '@/services/ai';

interface UseProjectDescGeneratorReturn {
  description: string;
  isLoading: boolean;
  error: string | null;
  generate: (input: ProjectDescInput) => Promise<void>;
  reset: () => void;
}

export function useProjectDescGenerator(): UseProjectDescGeneratorReturn {
  const [description, setDescription] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const generate = useCallback(async (input: ProjectDescInput) => {
    setIsLoading(true);
    setError(null);

    try {
      const result = await generateProjectDescription(input);
      setDescription(result);
    } catch (err) {
      setError(err instanceof Error ? err.message : 'エラーが発生しました');
    } finally {
      setIsLoading(false);
    }
  }, []);

  const reset = useCallback(() => {
    setDescription('');
    setError(null);
  }, []);

  return { description, isLoading, error, generate, reset };
}
